import { useEffect, useRef } from 'react';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { AnalyticsAttributesUntyped } from '@atlassian/jira-product-analytics-bridge/src/types';
import {
	useBulkOperationType,
	useBulkOperationsActions,
} from '@atlassian/jira-bulk-operations-common/src/controllers/use-bulk-operations/index.tsx';

export const useFlagAnalytics = (attributes: AnalyticsAttributesUntyped): void => {
	const analyticsEventFired = useRef(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const bulkOperationType = useBulkOperationType();
	const { resetState } = useBulkOperationsActions();

	useEffect(() => {
		if (!analyticsEventFired.current) {
			const analyticsEvent = createAnalyticsEvent({
				actionSubject: 'bulkProcess',
				action: 'complete',
			});

			const analyticsAttributes = {
				...attributes,
				bulkOperationType: bulkOperationType?.type,
			};
			fireUIAnalytics(analyticsEvent, analyticsAttributes);
			resetState();
			analyticsEventFired.current = true;
		}
	}, [createAnalyticsEvent, attributes, bulkOperationType?.type, resetState]);
};
